import Vue from 'vue'
import Vuex from 'vuex'

import dominios from './dominios';
import auth from './auth';
import alerts from './alerts';
import contents from './contents';
import alumni from './alumni';

Vue.use(Vuex)

let server = 'https://crm.alumni-ufv.es/';
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.includes('dev.doubledot.es')){
   server = 'https://dmb-alumni.dev.doubledot.es/';
}

export default new Vuex.Store({
  state: {
    language: 'es',
    server: server,
    showmenuperfil: false
  },
  getters: {
    getShowmenuperfil: state => state.showmenuperfil,
  },
  mutations: {
    toggleMenuPerfil(state) {
      state.showmenuperfil = !state.showmenuperfil
    }
  },
  actions: {
    toggleMenuPerfil({ commit }) {
      commit('toggleMenuPerfil');
    },
    initapp({ dispatch, getters }) {
      if (getters.getLogged) {
        dispatch('getAlumni')
      }
    }
  },
  modules: {
    dominios,
    auth,
    alerts,
    contents,
    alumni
  }
})
